import { useTheme } from "@/app/providers/ThemeProvider";
import { Sun, Moon } from "lucide-react";

export function ThemeToggle() {
  const { mode, toggle } = useTheme();

  return (
    <button
      onClick={toggle}
      className="p-2 rounded-md hover:bg-primary-container/40 transition"
    >
      {mode === "light" ? <Moon size={18} /> : <Sun size={18} />}
    </button>
  );
}
